import Tittle from "./Tittle";
import PropTypes from "prop-types";
import styles from "./HistorySection.module.css";

const HistorySection = ({ className = "" }) => {
  return (
    <div className={[styles.historySection, className].join(" ")}>
      <div className={[styles.container, "container"].join(" ")}>
        <div className={styles.historyText}>
          <div className={styles.text}>
            <Tittle
              text="Como surgiu?"
              mode="claro"
              className={styles.Tittle}
            />
            <p>
              Em 2021 com a aprovação da Superintendência de Seguros Privados
              (SUSEP) a Benefit passa a oferecer novos produtos a seus clientes, no que tange a gestão de transferências de riscos patrimoniais, empresariais e residenciais.
            </p>
          </div>
        </div>
        <div className={styles.img}>
          <img className={styles.historyImgIcon} alt="" src="/history-img.png" />
        </div>
      </div>
    </div>
  );
};

HistorySection.propTypes = {
  className: PropTypes.string,
};

export default HistorySection;
